import { generatePath } from 'react-router-dom';
import { Endpoint } from '@/Config/api/endpoint';
import { httpClient } from '@/Config/api/httpClient.config';
import { PaginatedParamsDto } from '@/Domain/api/App/dto/Params.dto';
import {
  ArticleDto,
  ArticleInputDto,
  ParagraphDto,
  ParagraphInputDto,
} from '@/Domain/api/KnowledgeBase/dto/Article.dto';
import {
  ImportSinglePageDto,
  ImportMultiplePagesDto,
  ImportSitemapDto,
  ImportAllPagesDto,
} from '@/Domain/api/KnowledgeBase/dto/ImportUrl.dto';
import { Paginated } from '@/Domain/api/Shared/dto/Paginated.dto';
import { ApiMapper } from '@/Domain/mapper/App/Api.mapper';

export class KnowledgeBaseApi {
  static createArticle = (
    article: ArticleInputDto | ParagraphInputDto,
  ): Promise<ArticleDto | ParagraphDto> =>
    httpClient.post(Endpoint.knowledgeBase.articles.create, article).then(ApiMapper.toResponseData);

  static deleteArticle = (ids: number | number[]): Promise<void> =>
    httpClient.delete(Endpoint.knowledgeBase.articles.delete, {
      data: typeof ids === 'number' ? [ids] : ids,
    });

  static updateArticle = (
    articleId: number,
    data: ArticleDto | ParagraphDto,
  ): Promise<ArticleDto | ParagraphDto> =>
    httpClient
      .patch(generatePath(Endpoint.knowledgeBase.articles.update, { articleId }), data)
      .then(ApiMapper.toResponseData);

  static uploadFile = (file: File): Promise<{ article: ArticleDto }> => {
    const formData = new FormData();
    formData.append('file', file);

    return httpClient
      .post(Endpoint.knowledgeBase.articles.uploadFile, formData)
      .then(ApiMapper.toResponseData);
  };

  static importSinglePage = (data: ImportSinglePageDto): Promise<ArticleDto> =>
    httpClient.post(Endpoint.knowledgeBase.website.singlePage, data).then(ApiMapper.toResponseData);

  static importMultiplePages = (data: ImportMultiplePagesDto): Promise<ArticleDto> =>
    httpClient
      .post(Endpoint.knowledgeBase.website.multiplePages, data)
      .then(ApiMapper.toResponseData);

  static importSitemap = (data: ImportSitemapDto): Promise<ArticleDto> =>
    httpClient.post(Endpoint.knowledgeBase.website.sitemap, data).then(ApiMapper.toResponseData);

  static importAllPages = (data: ImportAllPagesDto): Promise<ArticleDto> =>
    httpClient.post(Endpoint.knowledgeBase.website.allPages, data).then(ApiMapper.toResponseData);

  static paragraphsList = (params: PaginatedParamsDto): Promise<Paginated<ParagraphDto[]>> =>
    httpClient.get(Endpoint.knowledgeBase.paragraphs, { params }).then(ApiMapper.toResponseData);
}
